import React from 'react';
import AMapLoader from '@amap/amap-jsapi-loader';
import {getCurrentShopId} from '../shop/get-current-shop';
import { PhoneOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { Checkbox } from 'antd';

export default (props) => {
    let map = null;
    let currentPosition = null;
    const urlParams = new URLSearchParams(window.location.search);
    const currentDay = urlParams.get('day') || dayjs().format('YYYY-MM-DD');
    const [shopId, setShopId] = React.useState(null);
    const [onlyToday, setOnlyToday] = React.useState(true);
    
    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
        };
        
        fetchShopId();
    }, []);
    
    React.useEffect(() => {
        if (shopId) {
            loadData();
        }
    }, [shopId]);
    
    const loadData = () => {
        renderMap({onlyToday: true});
    }

    const renderMap = async ({onlyToday = false}) => { 
        // 清理之前的地图实例和标签
        if (map) {
            map.destroy();
            map = null;
        }
        
        // 清理地图容器中的所有信息标签
        const mapContainer = document.getElementById('container');
        if (mapContainer) {
            const existingLabels = mapContainer.querySelectorAll('.route-info');
            existingLabels.forEach(label => label.remove());
        } 
        window._AMapSecurityConfig = {
            securityJsCode: "551a981050d8a02cad26cac1e03bc180",
        };
        const day = new URLSearchParams(window.location.search).get('day');
        const startDate = day ? dayjs(day).startOf('day') : dayjs().startOf('day');
        const endDate = day ? dayjs(day).endOf('day') : dayjs().endOf('day');

        let apps = await getAppointments({shopId, startDate, endDate});
        let noApps = await getNoAppointments({shopId});

        apps = apps.map((item) => {
            return {
                ...item,
                hasAppointment: true,
                location: item.location ? item.location.split(',').map(item => +item) : null,
            }
        });
        if(!onlyToday) {
            noApps = noApps.map((item) => {
                return {
                    ...item,
                    hasAppointment: false,
                    location: item.location ? item.location.split(',').map(item => +item) : null,
                }
            });

            apps = apps.concat(noApps);
        }
        let center;

        if(apps?.length) {

            const points = [];
            apps.forEach(item => {
                if(item.location) points.push(item.location);
            });
            if(points.length) center = getAverageCenter(points);
            console.log('center', center);
        }

        AMapLoader.load({
            key: "0c20920ea05c8bc27b3498250770d89c", // 申请好的Web端开发者Key，首次调用 load 时必填
            version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            plugins: ["AMap.Scale", "AMap.Geolocation", "AMap.Weather", "AMap.Driving"], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
        })
            .then((AMap) => {
                map = new AMap.Map("container", {
                    // 设置地图容器id
                    viewMode: "2D", // 是否为3D地图模式
                    zoom: 11, // 初始化地图级别
                    center: center || [116.397428, 39.90923], // 初始化地图中心点位置
                });

                map.plugin(["AMap.Scale"], function () {
                    const p = new AMap.Scale();
                    p.addTo(map);
                });

                map.plugin(["AMap.Geolocation"], function () {
                    const p = new AMap.Geolocation();
                    p.addTo(map);

                    p.getCurrentPosition(function(status,result) {
                        if(status=='complete'){
                            console.log('=====>', result)
                            currentPosition = result.position ? [ result.position.lng, result.position.lat ] : null;
                            const points = [...apps];

                            if(currentPosition) {
                                points.push({ 
                                    location: currentPosition, 
                                    appointmentTime: dayjs(currentDay).startOf('day').toISOString(),
                                    status: 0,
                                });
                            }
                            
                            renderWay(map, AMap, points);
                        }else{
                            // onError(result)
                        }
                    });
                });

                // 添加标记
                renderMarker( map, AMap, apps);

                // 实时交通图层
                // const traffic = new AMap.TileLayer.Traffic({
                //     autoRefresh: true, //是否自动刷新
                //     interval: 180, //刷新间隔，默认180s
                // });

                // map.add(traffic);
            })
            .catch((e) => {
                console.log(e);
            });

        return () => {
            map?.destroy();
        };
    };

    const getAppointments = async ({startDate, endDate, shopId}) => {
        const params = new URLSearchParams();
        params.append('shopId', shopId);

        if (startDate) {
            params.append('startDate', startDate);
        }
        if (endDate) {
            params.append('endDate', endDate);
        }

        let response = await fetch(`/api/order/appointment?${params.toString()}`);
        let result = await response.json();

        if (result.success) {
            return result?.data?.rows || [];
        }

        return [];
    }

    const getNoAppointments = async ({shopId}) => {
        const params = new URLSearchParams();
        params.append('shopId', shopId);

        let response = await fetch(`/api/order/no-appointment?${params.toString()}`);
        let result = await response.json();

        if(result.success){
        return result?.data?.rows || [];
        }

        return [];
    }

    const onMarkOptChange = (e) => {
        setOnlyToday(e.target.checked);
        renderMap({onlyToday: e.target.checked});
    }

    const renderMarker = (map, AMap, apps) => { 
        let greenIcon = '/image/poi_green.png';
        let redIcon = '/image/poi_red.png';

        apps.forEach(p => {
            console.log('p============>', p);
            if(!p.location) return;
            
            const appTime = p.appointmentTime ? dayjs(p.appointmentTime).format('MMDD HH:mm') : '待预约';
            const action = `第${p.times}次服务`;

            const marker = new AMap.Marker({
                icon: p.status !== 0 ? greenIcon : redIcon,
                position: new AMap.LngLat(p.location[0], p.location[1]),
                title: '点',
                offset: new AMap.Pixel(-16, -32),
                zIndex: p.status === 0 ? 2 : 1,
                label: {
                    content: `${appTime} ${action}<br />${p.community || ''}${p.address} <a style='margin-right: 10px' href='tel:${p.phoneNo}'>电话</a>`
                }
            })

            map.add(marker);
        });
    }

    const renderWay = (map, AMap, points) => { 
        if(points.length) {
            points.sort((a, b) => {
                return dayjs(a.appointmentTime).isBefore(dayjs(b.appointmentTime)) ? -1 : 1;
            });
        }

        console.log('points============>', points);
        //引入和创建驾车规划插件
        AMap.plugin(["AMap.Driving"], function () {
            const driving = new AMap.Driving({
                map: map,
                // panel: "path", //参数值为你页面定义容器的 id 值<div id="my-panel"></div>
            });

            // 使用途经点进行整体路径规划（最多支持16个途经点）
            if (points.length >= 2) {
                // 准备路径规划数据：起点、途经点、终点
                const routePoints = [];
                
                points.forEach(point => {
                    if (point.location && point.status === 0) {
                        routePoints.push(point.location);
                    }
                });
                
                if (routePoints.length >= 2) {
                    const startPoint = routePoints[0];
                    const endPoint = routePoints[routePoints.length - 1];
                    const waypoints = routePoints.slice(1, -1); // 中间的点作为途经点
                    
                    console.log('起点:', startPoint);
                    console.log('终点:', endPoint);
                    console.log('途经点:', waypoints);
                    
                    // 使用途经点进行驾车规划
                    driving.search(startPoint, endPoint, {
                        waypoints: waypoints // 设置途经点
                    }, function (status, result) {
                        if (status === "complete") {
                            console.log('途经点路径规划成功:', result);
                            
                            // 提取路径信息
                            const routes = result.routes;
                            if (routes && routes.length > 0) {
                                const route = routes[0]; // 获取第一条路径
                                const distance = route.distance; // 总距离（米）
                                const time = route.time; // 总时间（秒）
                                
                                // 格式化显示信息
                                const distanceKm = (distance / 1000).toFixed(1); // 转换为公里
                                const timeMinutes = Math.ceil(time / 60); // 转换为分钟并向上取整
                                const timeHours = timeMinutes > 60 ? 
                                    `${Math.floor(timeMinutes / 60)}小时${timeMinutes % 60}分钟` : 
                                    `${timeMinutes}分钟`;
                                
                                // 为途经点路径添加分段时间标签
                                if (route.steps && route.steps.length > 0) {
                                    addWaypointSegmentLabels(route.steps, routePoints);
                                }
                                
                                // 创建路径信息提示
                                const routeInfo = `
                                    <div style="
                                        position: absolute; 
                                        top: 50px; 
                                        left: 10px; 
                                        z-index: 20; 
                                        background: rgba(0,0,0,0.8); 
                                        color: white; 
                                        padding: 10px 15px; 
                                        border-radius: 8px; 
                                        font-size: 14px;
                                        box-shadow: 0 2px 10px rgba(0,0,0,0.3);
                                        max-width: 250px;
                                    ">
                                        <div style="font-weight: bold; margin-bottom: 5px;">🚗 路径信息</div>
                                        <div>📍 总距离：${distanceKm} 公里</div>
                                        <div style="font-size: 12px; margin-top: 5px; opacity: 0.8;">途经 ${waypoints.length} 个地点</div>
                                    </div>
                                `;
                                
                                // 将路径信息添加到地图容器
                                const mapContainer = document.getElementById('container');
                                if (mapContainer) {
                                    // 移除之前的路径信息（如果存在）
                                    const existingInfo = mapContainer.querySelector('.route-info');
                                    if (existingInfo) {
                                        existingInfo.remove();
                                    }
                                    
                                    // 添加新的路径信息
                                    const infoDiv = document.createElement('div');
                                    infoDiv.className = 'route-info';
                                    infoDiv.innerHTML = routeInfo;
                                    mapContainer.appendChild(infoDiv);
                                }
                                
                                // 控制台输出详细信息
                                console.log(`🚗 路径规划完成：`);
                                console.log(`📍 总距离：${distanceKm} 公里`);
                                console.log(`⏱️ 预计时间：${timeHours}`);
                                console.log(`🎯 途经点数量：${waypoints.length}`);
                                
                                // 如果有分段信息，也可以显示
                                if (route.steps && route.steps.length > 0) {
                                    console.log(`📋 路径分段数：${route.steps.length}`);
                                }
                            }
                        } else {
                            console.log("途经点路径规划失败：" + result);
                            // 如果途经点规划失败，回退到点对点规划
                            // fallbackToPointToPoint();
                        }
                    });
                    
                // 为途经点路径添加分段时间标签的函数
                function addWaypointSegmentLabels(steps, routePoints) {
                    // 尝试根据路径点数量分配步骤
                    const segmentCount = routePoints.length - 1;
                    
                    if (segmentCount <= 0) return;
                    
                    // 将步骤按段分组
                    const stepsPerSegment = Math.floor(steps.length / segmentCount);
                    
                    for (let segIndex = 0; segIndex < segmentCount; segIndex++) {
                        const startPointIndex = segIndex;
                        const endPointIndex = segIndex + 1;
                        
                        if (startPointIndex >= routePoints.length || endPointIndex >= routePoints.length) {
                            continue;
                        }
                        
                        const startPoint = routePoints[startPointIndex];
                        const endPoint = routePoints[endPointIndex];
                        
                        // 获取该段的步骤
                        const segmentStartStep = segIndex * stepsPerSegment;
                        const segmentEndStep = segIndex === segmentCount - 1 ? 
                            steps.length : (segIndex + 1) * stepsPerSegment;
                        
                        let segmentTime = 0;
                        let segmentDistance = 0;
                        
                        // 统计该段的时间和距离
                        for (let stepIndex = segmentStartStep; stepIndex < segmentEndStep; stepIndex++) {
                            if (steps[stepIndex]) {
                                segmentTime += steps[stepIndex].time || 0;
                                segmentDistance += steps[stepIndex].distance || 0;
                            }
                        }
                        
                        // 添加该段的时间标签
                        if (segmentTime > 0) {
                            addSegmentTimeLabel(startPoint, endPoint, segmentTime, segmentDistance, segIndex + 1);
                        }
                    }
                }
                }
            }
            
            // 为路径段添加时间提示标签的函数
            function addSegmentTimeLabel(startPoint, endPoint, time, distance, segmentIndex) {
                // 计算中点位置
                // const midLat = (startPoint[1] + endPoint[1]) / 2;
                // const midLng = (startPoint[0] + endPoint[0]) / 2;

                const midLat = (0 + endPoint[1]);
                const midLng = (0 + endPoint[0]);
                
                // 格式化时间和距离
                const timeMinutes = Math.ceil(time / 60);
                const timeText = timeMinutes > 60 ? 
                    `${Math.floor(timeMinutes / 60)}小时${timeMinutes % 60}分` : 
                    `${timeMinutes}分钟`;
                const distanceKm = (distance / 1000).toFixed(1);
                
                // 创建时间标签标记点
                const timeLabel = new AMap.Marker({
                    position: new AMap.LngLat(midLng, midLat),
                    content: `
                        <div style="
                            background: rgba(74, 144, 226, 0.9);
                            color: white;
                            padding: 6px;
                            border-radius: 10px 10px 0 10px;
                            font-size: 12px;
                            font-weight: bold;
                            box-shadow: 0 2px 8px rgba(0,0,0,0.3);
                            border: 1px solid white;
                            text-align: center;
                            min-width: 125px;
                            transform: translate(-50%, -50%);
                        ">
                            <div style="margin: 2px 0;">⏱️ ${timeText}/${distanceKm}km</div>
                        </div>
                    `,
                    anchor: 'center',
                    zIndex: 100,
                    offset: new AMap.Pixel(-10, 0)
                });
                
                // 将标签添加到地图
                map.add(timeLabel);
                
                console.log(`✅ 第${segmentIndex}段路径标签已添加: ${timeText}, ${distanceKm}km`);
            }
        });
    }

    return (
        <div style={{ position: 'relative'}}>
            <div style={{ position: 'absolute', top: 10, left: 10, zIndex: 10, padding: 4, background: '#fff', boxShadow: '0 0 5px #ccc', borderRadius: '3px' }}>
                <Checkbox onChange={onMarkOptChange} checked={onlyToday}>
                    仅显示当日
                </Checkbox>
            </div>
            <div
                id="container"
                style={{ height: "680px" }}
            ></div>
            <div id="path"></div>
        </div>
    );
        
}

function getAverageCenter(points) {
    const lng = [];
    points.forEach(p => lng.push(+p[1]));
    const lat = [];
    points.forEach(p => lat.push(+p[0]));

    return [
        ( Math.max(...lat) + Math.min(...lat) ) / 2,
        ( Math.max(...lng) + Math.min(...lng) ) / 2,
    ];
}